module.exports = __webpack_public_path__ + "img/pr-6.12be10de.png";